(() => {
  if (customElements.get('sniffcar-packaging-carousel')) return;

  class SniffcarPackagingCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-packaging-track]');
      this.slides = Array.from(this.querySelectorAll('[data-packaging-slide]'));
      this.navigation = this.querySelector('[data-packaging-navigation]');
      this.previous = this.querySelector('[data-packaging-previous]');
      this.next = this.querySelector('[data-packaging-next]');
      this.counter = this.querySelector('[data-packaging-counter]');
      if (!this.track || !this.slides.length || !this.navigation) return;

      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.index = 0;
      this.previous.addEventListener('click', () => this.goTo(this.index - 1), options);
      this.next.addEventListener('click', () => this.goTo(this.index + 1), options);
      this.track.addEventListener('scroll', () => this.queueUpdate(), { ...options, passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const destination = event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1);
        this.goTo(destination);
      }, options);
      this.resizeObserver?.disconnect();
      this.resizeObserver = new ResizeObserver(() => this.queueUpdate());
      this.resizeObserver.observe(this.track);
      this.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('[data-packaging-slide]');
        const index = this.slides.indexOf(slide);
        if (index >= 0) this.goTo(index);
      }, options);
      this.update();
    }

    disconnectedCallback() {
      this.events?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.updateFrame);
    }

    positions() {
      const left = this.track.getBoundingClientRect().left;
      return this.slides.map((slide) => slide.getBoundingClientRect().left - left + this.track.scrollLeft);
    }

    queueUpdate() {
      cancelAnimationFrame(this.updateFrame);
      this.updateFrame = requestAnimationFrame(() => this.update());
    }

    update() {
      const scrollable = this.track.scrollWidth > this.track.clientWidth + 2;
      this.navigation.hidden = !scrollable;
      this.track.tabIndex = scrollable ? 0 : -1;
      const positions = this.positions();
      this.index = positions.reduce((nearest, position, index) => Math.abs(position - this.track.scrollLeft) < Math.abs(positions[nearest] - this.track.scrollLeft) ? index : nearest, 0);
      this.previous.disabled = this.index === 0;
      this.next.disabled = this.index === this.slides.length - 1;
      const label = `${this.index + 1} / ${this.slides.length}`;
      if (this.counter.textContent !== label) this.counter.textContent = label;
    }

    goTo(index) {
      const destination = Math.min(Math.max(index, 0), this.slides.length - 1);
      this.track.scrollTo({
        left: this.positions()[destination],
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }
  }

  customElements.define('sniffcar-packaging-carousel', SniffcarPackagingCarousel);
})();
